<template>
  <div>
    <b-tabs>
      <b-tab title="filtering">
        <b-row>
          <b-col cols="6">
            <b-form-group label="Open corporate options">
              <b-form-checkbox
                :disabled="searchPage"
                v-model="$store.state.priConfigrationforms.openCorporate.companyNumber"
              >Enable Search By Company Number</b-form-checkbox>
              <b-form-checkbox
                :disabled="searchPage"
                v-model="$store.state.priConfigrationforms.openCorporate.partialSearch"
              >Enable Partial Search</b-form-checkbox>
              <b-form-checkbox
                :disabled="searchPage"
                v-model="$store.state.priConfigrationforms.openCorporate.globalSearch"
              >Enable Global Search</b-form-checkbox>
              <b-form-checkbox
                :disabled="searchPage"
                v-model="$store.state.priConfigrationforms.openCorporate.stopWords"
              >Remove Stop Words</b-form-checkbox>
            </b-form-group>
          </b-col>
          <b-col cols="6">
            <div>
              <p>Copy Stop Words</p>
              <b-input-group class="mt-3">
                <template v-slot:prepend>
                  <b-button
                    variant="outline-warning"
                    :disabled="searchPage"
                    @click="copyAllStopWords"
                    style="height:35px;"
                  >Add All</b-button>
                </template>
                <v-select
                  :disabled="searchPage"
                  size="sm"
                  :searchable="true"
                  :clearable="true"
                  :multiple="true"
                  label="text"
                  v-model="selectStopWords"
                  :options="stopWordsList"
                  style="width: 72%;"
                >
                  <template #search="{ attributes, events }">
                    <input
                      class="vs__search"
                      v-bind="attributes"
                      v-on="events"
                      @focus="copyStopWords()"
                    />
                  </template>
                </v-select>
                <b-input-group-append>
                  <b-button
                    :disabled="searchPage"
                    variant="outline-warning"
                    @click="pasteStopWords"
                    style="height:35px;"
                  >Add</b-button>
                </b-input-group-append>
              </b-input-group>
            </div>
            <div class="mt-3">
              <b-form-checkbox
                :disabled="searchPage"
                v-model="$store.state.priConfigrationforms.openCorporate.disableRemovalText"
              >Disable the removal of text in (Text)</b-form-checkbox>
            </div>
            <b-card>
              <h4>Stop Keywords</h4>
              <b-input-group class="mt-3">
                <b-form-input
                  :disabled="searchPage"
                  placeholder="Enter the phrases you would like to be removed from the search string..."
                  @keyup.enter="addStopWords()"
                  v-model="addStopWord"
                ></b-form-input>
                <b-input-group-append>
                  <b-button
                    :disabled="searchPage"
                    @click="addStopWords"
                    variant="outline-warning"
                  >Add</b-button>
                </b-input-group-append>
              </b-input-group>
              <b-table
                :items="$store.state.priConfigrationforms.openCorporate.stopWordsList"
                :fields="fieldsKeywords"
              >
                <template v-slot:cell(text)="data">
                  <p>{{data.item}}</p>
                </template>
                <template v-slot:cell(actions)="data">
                  <b-button
                    :disabled="searchPage"
                    @click="removeStopWords(data)"
                    variant="danger"
                    size="sm"
                  >
                    <font-awesome-icon icon="trash"></font-awesome-icon>
                  </b-button>
                </template>
              </b-table>
            </b-card>
          </b-col>
        </b-row>
      </b-tab>
      <b-tab title="scoring">
        <b-row>
          <b-col cols="6">
            <b-form-group>
              <b-input-group class="mt-4">
                <template v-slot:prepend>
                  <b-input-group-text>
                    <strong class="text-danger">Very Rare</strong>
                  </b-input-group-text>
                </template>
                <b-form-input
                  :disabled="searchPage"
                  v-model="$store.state.priConfigrationforms.openCorporate.veryRare"
                  type="number"
                ></b-form-input>
              </b-input-group>
            </b-form-group>
            <b-form-group>
              <b-input-group class="mt-4">
                <template v-slot:prepend>
                  <b-input-group-text>
                    <strong class="text-danger">Rare</strong>
                  </b-input-group-text>
                </template>
                <b-form-input
                  :disabled="searchPage"
                  v-model="$store.state.priConfigrationforms.openCorporate.rare"
                  type="number"
                ></b-form-input>
              </b-input-group>
            </b-form-group>
          </b-col>
          <b-col cols="6">
            <b-form-group>
              <b-input-group class="mt-4">
                <template v-slot:prepend>
                  <b-input-group-text>
                    <strong class="text-danger">Common</strong>
                  </b-input-group-text>
                </template>
                <b-form-input
                  :disabled="searchPage"
                  v-model="$store.state.priConfigrationforms.openCorporate.common"
                  type="number"
                ></b-form-input>
              </b-input-group>
            </b-form-group>
            <b-form-group>
              <b-input-group class="mt-4">
                <template v-slot:prepend>
                  <b-input-group-text>
                    <strong class="text-danger">Very Common</strong>
                  </b-input-group-text>
                </template>
                <b-form-input
                  :disabled="searchPage"
                  v-model="$store.state.priConfigrationforms.openCorporate.veryCommon"
                  type="number"
                ></b-form-input>
              </b-input-group>
            </b-form-group>
          </b-col>
        </b-row>
      </b-tab>
    </b-tabs>
  </div>
</template>

<script>
export default {
  name: "OpenCorporateComponent",
  data() {
    return {
      addStopWord: null,
      fieldsKeywords: [
        {
          key: "text",
          label: "Keyword"
        },
        {
          key: "Actions",
          label: "Actions"
        }
      ],
      selectStopWords: [],
      stopWordsList: []
    };
  },
  mounted() {},
  methods: {
    copyStopWords() {
      this.stopWordsList = [];
      if (
        this.$store.state.priConfigrationforms.futureRisks.categories.length > 0
      ) {
        this.$store.state.priConfigrationforms.futureRisks.categories.map(
          futureRisksCategoriesData => {
            futureRisksCategoriesData.stopWords.map(stopWordsData => {
              this.stopWordsList.push({
                text: stopWordsData,
                value: stopWordsData
              });
            });
          }
        );
      }
      if (
        this.$store.state.priConfigrationforms.negativeMedia.categories.length >
        0
      ) {
        this.$store.state.priConfigrationforms.negativeMedia.categories.map(
          negativeMediaCategoriesData => {
            negativeMediaCategoriesData.stopWords.map(stopWordsData => {
              this.stopWordsList.push({
                text: stopWordsData,
                value: stopWordsData
              });
            });
          }
        );
      }
    },
    copyAllStopWords() {
      let stopWordsData = [];
      if (
        this.$store.state.priConfigrationforms.negativeMedia.categories.length >
        0
      ) {
        this.$store.state.priConfigrationforms.negativeMedia.categories.map(
          negativeMediaCategoriesData => {
            negativeMediaCategoriesData.stopWords.map(stopWordsValue => {
              stopWordsData.push(stopWordsValue);
            });
          }
        );
      }
      if (
        this.$store.state.priConfigrationforms.futureRisks.categories.length > 0
      ) {
        this.$store.state.priConfigrationforms.futureRisks.categories.map(
          futureRisksCategoriesData => {
            futureRisksCategoriesData.stopWords.map(stopWordsValue => {
              stopWordsData.push(stopWordsValue);
            });
          }
        );
      }

      stopWordsData.map(value => {
        this.$store.state.priConfigrationforms.openCorporate.stopWordsList.unshift(
          value
        );
      });
    },
    pasteStopWords() {
      this.selectStopWords.map(value => {
        this.$store.state.priConfigrationforms.openCorporate.stopWordsList.unshift(
          value.text
        );
      });
      this.stopWordsList = [];
      this.selectStopWords = [];
    },
    addStopWords() {
      if (this.addStopWord) {
        this.$store.state.priConfigrationforms.openCorporate.stopWordsList.unshift(
          this.addStopWord
        );
      }
      this.addStopWord = null;
    },
    removeStopWords(data) {
      let stopWordsData = this.$store.state.priConfigrationforms.openCorporate
        .stopWordsList;
      let stopWordsIndex = stopWordsData.indexOf(data.item);
      stopWordsData.splice(stopWordsIndex, 1);
    }
  },
  props: {
    searchPage: Boolean
  }
};
</script>
